import {http} from "../http/http";

// import store  from '../../store'


// function getCategoriesEvents() {
//     return new Promise((resolve, reject) => {
//         http.get("todos/1").then((result) => {
//             resolve(result);
//         }).catch((error) => {
//             reject(error);//ver si se puede devolver el error. pero si no, dejarlo como esta
//         });
//     })
// }
//
// function getCategoriesVenues() {
//     return new Promise((resolve, reject) => {
//         http.get("todos/1").then((result) => {
//             resolve(result);
//         }).catch((error) => {
//             reject(error);
//         });
//     })
// }




export default {


    // getDataFunction: (functions) => {
    //     return new Promise((resolve, reject) => {
    //         var arrayDeFunciones = [];
    //         //copiamos las funciones que necesitamos
    //         functions.forEach(function (e) {
    //             arrayDeFunciones.push((eval(e)));
    //         });
    //         var arrayDeRespuestas = [];
    //         arrayDeFunciones.forEach(function (e) {
    //            new Promise((resolve, reject) => {
    //                 e().then((result) => {
    //                     arrayDeRespuestas.push(result);
    //                 }).catch((error) => {
    //                     arrayDeRespuestas.push(error);
    //                 })
    //             })
    //         });
    //        resolve(arrayDeRespuestas);
    //     });
    // },


    getQuestions: (data) => {
        return new Promise((resolve, reject) => {
            http.post("next", data).then((result) => {
                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    sendMailRegister: (data)=>{
        return new Promise((resolve, reject)=>{
            http.post('submitPoll', data).then((response)=>{
                resolve(response);
            }).catch((error)=>{
                reject(error)
            })
        })
    }



    // login: (data) => {
    //     return new Promise((resolve, reject) => {
    //         http.post("/login",data).then((result) => {
    //             resolve(result);
    //         }).catch((error) => {
    //             reject(error);
    //         });
    //     });
    // },


};



